import { indexCategories } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">片库索引</h2>
          <p className="text-sm text-foreground-500 mt-2">按类型快速浏览海量电影片库</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {indexCategories.slice(0, 5).map((cat) => (
            <div key={cat.id} className="bg-background-50 rounded-xl p-5 text-center group cursor-pointer border border-background-200/60 transition-all hover:bg-background-200">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mt-3">{cat.name}</h3>
              <p className="text-xs text-foreground-400 mt-1">{cat.count}</p>
            </div>
          ))}
          {indexCategories.slice(5).map((cat) => (
            <div key={cat.id} className="bg-background-50 rounded-xl p-5 text-center group cursor-pointer border border-background-200/60 transition-all hover:bg-background-200">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mt-3">{cat.name}</h3>
              <p className="text-xs text-foreground-400 mt-1">{cat.count}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}